import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { isItemLiked } from '@/js/lib/api/v1/item';
import { useUserStore } from './user';
import { pinia } from '.';

const userStore = useUserStore(pinia);

export const useItemStore = defineStore('item', () => {
  const likedItemIds = ref<number[]>([]);

  async function checkLiked(itemIds: number[]) {
    if (userStore.isAuthenticated) {
      const likedList = await isItemLiked({ itemIds });
      likedItemIds.value = uniq([...likedItemIds.value, ...likedList.filter((item) => item.liked === 1).map((item) => Number(item.itemId))]);
    }
  }
  function addLiked(itemId: number) {
    if (!likedItemIds.value.includes(itemId)) {
      likedItemIds.value.push(itemId);
    }
  }
  function removeLiked(itemId: number) {
    const index = likedItemIds.value.indexOf(itemId);
    if (index !== -1) {
      likedItemIds.value.splice(index, 1);
    }
  }

  return { likedItemIds: readonly(likedItemIds), checkLiked, addLiked, removeLiked };
});
